"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var AddressInputAccount_1 = __importDefault(require("./AddressInputAccount"));

var classes = require('./AddressInputSearchResults.module.css');

var AddressInputSearchResults = function AddressInputSearchResults(_a) {
  var accounts = _a.accounts,
      onSelect = _a.onSelect;
  return react_1.default.createElement("div", {
    className: classes.results
  }, react_1.default.createElement("ul", {
    className: classes.list
  }, accounts.map(function (account) {
    return react_1.default.createElement("li", {
      className: classes.listElement + " " + (account.address ? classes.enabled : ''),
      onClick: function onClick() {
        return account.address && onSelect(account);
      },
      key: account.address || account.name
    }, react_1.default.createElement(AddressInputAccount_1.default, {
      account: account
    }));
  })));
};

exports.default = AddressInputSearchResults;